var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 358,
    viewBox: "0 0 343 358",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1239_4259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.51 325.02L8.02148 249.486L78.1611 124.314L196.858 111.365L334.979 187.979L278.867 302.36L137.51 325.02Z",
    stroke: "#F7DBFF",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.213 395.096L-99.2168 270.013L16.9327 62.7319L213.492 41.2891L442.216 168.159L349.297 357.571L115.213 395.096Z",
    stroke: "#F7DBFF",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9894 477.514L-225.342 294.155L-55.0794 -9.69602L233.055 -41.1289L568.34 144.849L432.13 422.506L88.9894 477.514Z",
    stroke: "#F7DBFF",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6788 575.924L-375.938 322.983L-141.062 -96.1768L256.416 -139.538L718.937 117.016L531.038 500.042L57.6788 575.924Z",
    stroke: "#F7DBFF",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5373 702.086L-569.004 359.939L-251.295 -207.046L286.364 -265.7L912.004 81.3343L657.838 599.442L17.5373 702.086Z",
    stroke: "#F7DBFF",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0391 223.327L96.3637 163.984L210.328 155.479L275.724 193.438L246.729 253.222L143.955 267.947L70.0391 223.327Z",
    fill: "#FE6533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9453 248.188V223.162L143.97 267.956V291.089L69.9453 248.188Z",
    fill: "#C7CDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9453 248.188V223.162L143.97 267.956V291.089L69.9453 248.188Z",
    fill: "url(#paint0_linear_1239_4259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9453 248.188V223.162L143.97 267.956V291.089L69.9453 248.188Z",
    fill: "#7A1600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.971 291.083V267.939L247.019 252.531V274.639L143.971 291.083Z",
    fill: "#6870FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.971 291.083V267.939L247.019 252.531V274.639L143.971 291.083Z",
    fill: "url(#paint1_linear_1239_4259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.971 291.083V267.939L247.019 252.531V274.639L143.971 291.083Z",
    fill: "#7A1600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.686 216.756V193.523L247.02 252.542V274.664L275.686 216.756Z",
    fill: "#FE6533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.686 216.756V193.523L247.02 252.542V274.664L275.686 216.756Z",
    fill: "#7A1600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.184 241.829V148.267L241.413 91.345V180.088C241.413 183.378 239.694 186.429 236.879 188.133L148.184 241.829Z",
    fill: "#F7DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.913 236.568C139.673 248.778 132.764 244.741 128.746 241.758L140.364 226.186L156.913 236.568Z",
    fill: "#EBDFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.072 217.74V130.59L148.182 146.846V230.627C148.182 240.811 136.957 246.998 128.347 241.56L117.385 234.636C111.588 230.975 108.072 224.597 108.072 217.74Z",
    fill: "#F7DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.394 75.1365L112.667 123.295C108.116 125.945 107.969 132.468 112.397 135.32L125.29 143.624C135.018 149.889 147.449 150.124 157.406 144.231L237.671 96.7238C241.69 94.3454 241.464 88.4566 237.275 86.3933L213.167 74.5186C207.513 71.7338 200.84 71.9658 195.394 75.1365Z",
    fill: "#FEF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.535 86.1816V133.822C126.535 133.822 128.989 140.639 137.358 140.335C145.727 140.031 147.553 132.879 147.553 132.879C147.553 121.01 145.477 94.4197 147.553 84.0347C149.957 72.0093 153.161 70.3519 155.923 65.2692C158.686 60.1865 179.232 39.7194 193.746 36.564C201.021 34.9826 202.84 41.3083 202.84 44.6689V88.3561C202.84 88.3561 205.339 95.5706 213.119 95.6702C220.899 95.7699 223.201 88.3561 223.201 88.3561V48.4248C223.201 40.2456 222.608 29.9615 213.119 22.5287C201.258 13.2378 180.107 15.2146 154.804 36.564C134.561 53.6435 127.524 76.7589 126.535 86.1816Z",
    fill: "#7A1600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.817 137.353C194.18 137.353 183.848 144.73 181.277 156.328C179.837 162.828 178.88 172.309 187.92 174.018L183.305 201.011C182.964 203.006 185.137 204.471 186.859 203.407L202.771 193.569C205.216 192.057 206.499 189.214 206.014 186.381L202.557 166.167C205.848 161.181 208.28 155.057 208.829 151.375C209.873 144.364 209.454 137.353 201.817 137.353Z",
    fill: "#7A1600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1239_4259",
    x1: 69.9453,
    y1: 235.738,
    x2: 270.176,
    y2: 404.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7152"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1239_4259",
    x1: 143.971,
    y1: 259.668,
    x2: 173.59,
    y2: 318.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7152"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1239_4259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 358,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSecurity);
export default __webpack_public_path__ + "static/media/Mobile_Security.903a45c4540760e7bd1f27f142da08e1.svg";
export { ForwardRef as ReactComponent };